import { Step } from "../../domain/entities/step/Step";
import { DefaultStep } from "../../domain/entities/step/DefaultStep";
import { ProcessInfoStep } from "../../domain/entities/step/ProcessInfoStep";
import { RequirementStep } from "../../domain/entities/step/RequirementStep";
import { AuthorizarionStep } from "../../domain/entities/step/AuthorizarionStep";
import { PayExemptionStep } from "../../domain/entities/step/PayExemptionStep";
import { PayFeeAmountStep } from "../../domain/entities/step/PayFeeAmountStep";
import { MeritGroupStep } from "../../domain/entities/step/MeritGroupStep";
import { ExamStep } from "../../domain/entities/step/ExamStep";
import { LegalStep } from "../../domain/entities/step/LegalStep";
import { PostMeritStep } from "../../domain/entities/step/PostMeritStep";
import { AdminPreviewInscriptionMeritStep } from "../../domain/entities/step/AdminPreviewInscriptionMeritStep";

export class StepFactory {
    createStep(type: Object): DefaultStep;
    createStep(type: Object): ProcessInfoStep;
    createStep(type: Object,processConfigurationPayExemptions?: any[]): PayExemptionStep;
    createStep(type: Object): RequirementStep;
    createStep(type: Object,[],processConfigurationAuthorizations?: any[]): AuthorizarionStep;
    createStep(type: Object): PayFeeAmountStep;
    createStep(type: Object): MeritGroupStep;
    createStep(type: Object): ExamStep;
    createStep(type: Object): LegalStep;
    createStep(type: Object): PostMeritStep;
    createStep(type: Object): AdminPreviewInscriptionMeritStep;

    public createStep(step: any, processConfigurationPayExemptions?: any[], processConfigurationAuthorizations?: any[] ): Step {
        switch (step.type) {
            case 2:
                return new ProcessInfoStep(step);
            case 4:
                return new PayExemptionStep(step, processConfigurationPayExemptions);
            case 6:
                return new RequirementStep(step);
            case 7:
                return new AuthorizarionStep(step, processConfigurationAuthorizations);
            case 8:
                return new PayFeeAmountStep(step);
            case 9:
                return new MeritGroupStep(step);
            case 10:
                return new ExamStep(step);
            case 11:
                return new LegalStep(step);
            case 12:
                return new PostMeritStep(step);
            case 13:
                return new AdminPreviewInscriptionMeritStep(step);
            default:
                return new DefaultStep(step);
        }
    }
}